import { THREAD_DEBUG_MODE_FULL, THREAD_DEBUG_MODE_OFF } from '@/lib/appConstants.js';

const normalizeThreadDebugMode = (value, fallback = THREAD_DEBUG_MODE_OFF) => {
  const normalized = String(value || '')
    .trim()
    .toLowerCase();

  if (!normalized) {
    return fallback;
  }

  if (normalized === THREAD_DEBUG_MODE_FULL || normalized === 'trace' || normalized === 'enabled' || normalized === 'on' || normalized === 'true' || normalized === '1') {
    return THREAD_DEBUG_MODE_FULL;
  }

  if (normalized === THREAD_DEBUG_MODE_OFF || normalized === 'disabled' || normalized === 'false' || normalized === '0') {
    return THREAD_DEBUG_MODE_OFF;
  }

  return fallback;
};

export default normalizeThreadDebugMode;
